import $ from "jquery";
import React, { Component } from "react";
import { formValueSelector, Field, change } from "redux-form";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";

import Loading from "components/Loading";
import { getWindowLocks, getWindowHandles } from "selectors";
import ChipsGrid from "components/ChipsGrid";
import { getAllWindowColours } from "./../../selectors";
import ImageResolver from "./../ImageResolver";
import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";
import FormWrapper from "../FormWrapper";
import utils from '../../utils';
import { updatePreviousSelection } from '../../actions';
import ExtraSwitchField from "../../components/ExtraSwitchField";


class SelectHandle extends Component {
    render() {
        let { handles, input } = this.props;

        if ($.isEmptyObject(handles)) {
            return <Loading />;
        }

        return (
            <div>
                <Row isColumn hideOnlyFor="small">
                    <h4>Handle</h4>
                </Row>
                <Row isColumn>
                    <ChipsGrid
                        colours={handles}
                        selectedId={input.value}
                        onChange={input.onChange}
                    />
                </Row>
                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class HandleForm extends Component {
    componentDidUpdate() {

        let { selectedStyle, selectedHandle, selectedColour, handles, dispatch, previousSelection, showLockOption } = this.props;

        if (!selectedHandle.id) {
            if (handles.length > 0) {

                var handleId = utils.getExtraBestMatch(handles, selectedColour, selectedStyle.useAltBestMatch);

                var previousHandleId = utils.findHandleByColour(handles, previousSelection.WindowHandleColour, "Standard");

                // do somthing
                dispatch(change("WindowWizard", "WindowHandleId", previousHandleId || handleId));

                if (previousSelection.WindowLock && showLockOption)
                    dispatch(change("WindowWizard", "YaleLock", previousSelection.WindowLock));
            }
        }
    }

    onSubmit(values) {

        var handle = utils.getValueById(this.props.handles, values.WindowHandleId);

        this.props.updatePreviousSelection({
            WindowHandleColour: handle.description1,
            WindowHandleType: handle.description2,
            WindowLock: values.YaleLock
        });

        this.props.onSubmit(values);
    }


    render() {
        let { selectedHandle, selectedColour, handleSubmit, handles,  upgradeExtra } = this.props;

        return (
            <form className="HandleForm" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader
                    title={"Handles & locks"}
                    subtitle={"We can supply a wide range of finish colours and textures."}
                />

                <SeparatingLine />

                <FormWrapper>
                    <Row collapseOnSmall uncollapseOnMedium>
                        <Column
                            pushOnLarge={7}
                            large={5}
                            className="preview-container"
                            style={{ position: "relative" }}
                        >
                            <ImageResolver
                                query={{
                                    productId: this.props.windowStyleId,
                                    colourId: selectedColour.id
                                }}
                                filters={{ extraId: selectedHandle.id }}
                            />
                        </Column>
                        <Column className="colour-name-container" showOnlyFor="small">
                            {selectedHandle.name}
                        </Column>
                        <Column className={"swatch-selector-container"} pullOnLarge={7} large={5}>
                            <Row isColumn>
                                <Field
                                    name="WindowHandleId"
                                    component={SelectHandle}
                                    handles={handles}
                                />
                            </Row>
                            {upgradeExtra && (
                                <ExtraSwitchField upgradeExtra={upgradeExtra} fieldName="YaleLock" />
                            )}
                        </Column>
                    </Row>
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("WindowWizard");
    let windowStyleId = valueSelector(state, "WindowStyleId");
    let windowHandleId = valueSelector(state, "WindowHandleId");
    let windowColourId = valueSelector(state, "WindowColourId");
    let windowDesignId = valueSelector(state, "WindowDesignId");
    let windowColourInterior = valueSelector(state, "WindowColourInterior");

    let handles = getWindowHandles(state);
    let colours = getAllWindowColours(state);

    var selectedHandle = handles.filter(h => h.id === windowHandleId)[0] || {};
    let selectedColour = colours.filter(c => c.id === windowColourId)[0];

    if (windowColourInterior && selectedColour.relatedColourId) {
        selectedColour = colours.filter(c => c.id === selectedColour.relatedColourId)[0];
    }

    const upgradableExtra = state.Window.Options.extras.find(extra => extra.upgradeExtraId);
    const upgradeExtra = state.Window.Options.extras.find(extra => extra.isUpgrade);

    if (upgradableExtra && (!upgradeExtra || upgradeExtra.id !== upgradableExtra.upgradeExtraId)) {
        console.error(
            `There was an error finding the extra upgrade. Found Upgradable extra id=${
                upgradableExtra.id
            } with upgradeExtraId=${upgradableExtra.upgradeExtraId} but no matching extra`
        );
    }

    let selectedStyle = state.Window.Styles.filter(c => c.id === windowStyleId)[0] || {};

    let selectedDesign = state.Window.Designs.filter(d => d.id === windowDesignId)[0] || {};

    var locks = getWindowLocks(state);

    return {
        handles,
        selectedHandle,
        selectedColour,
        windowStyleId,
        selectedStyle,
        showLockOption: selectedDesign.openingsCount !== 0 && locks.length === 2,
        previousSelection: state.PreviousSelection,
        upgradableExtra,
        upgradeExtra
    };
};

export default connect(mapStateToProps, { updatePreviousSelection })(HandleForm);



// WEBPACK FOOTER //
// ./src/containers/WindowForm/HandleForm.js